import * as dagreD3 from 'dagre-d3'
import * as d3 from 'd3'
import * as R from 'ramda'

// Converted this function to JS to avoid strange compilatiton issue with typescript
export default function renderGraph(svgElement, svgGroupElement, d3Graph, onSelectNode, onSelectEdge) {
  if (d3Graph && svgElement && svgGroupElement) {
    const render = new dagreD3.render()
    const inner = d3.select(svgGroupElement)
    render(inner, d3Graph)

    inner.selectAll('g.node, g.node rect, g.node ellipse, g.node text').on('click', function(d, _i) {
      if (onSelectNode) {
        onSelectNode(d)
      }
    })

    inner.selectAll('g.edgeLabel text').on('click', function(d, _i) {
      // console.log('On Select Edge', d, _i, arguments)
      if (onSelectEdge) {
        onSelectEdge(d.name)
      }
    })

    // Set up zoom support
    const svg = d3.select(svgElement)
    const zoom = d3.zoom().on('zoom', function() {
      inner.attr('transform', d3.event.transform)
    })
    svg.call(zoom)
  }
}

